import { Route } from "../core/routeGuard/applicationRoutesNg.service";
import { USE_NEW_SIGN_IN_PROCESS } from "./use-new-sign-in-process";

export default class CreateANewPasswordController {
  pw = '';

  pwConf = '';

  newPasswordForm;

  constructor(
    private $routeParams,
    private $location,
    private $window,
    private api,
    private DestinationService
  ) {
    'ngInject';

    if(USE_NEW_SIGN_IN_PROCESS) {
      this.$window.location.href = `${Route.CREATE_PASSWORD}?code=${$routeParams.code}`;
    }

    // Some of our password reset codes will expire after X number of days. We confirm that the one we got coming into
    // the page is still valid and if not, redirect the user to get a new password reset email and try again.
    this.api.useraccount.securitycodes($routeParams.code).then((response) => {
      if (!response.data.isValid) {
        $location.path('/resetPassword/expired');
      }
    });
  }

  // There are rules about password length (in fact those are the only password rules at the moment). We enforce those
  // so the user can see without submitting whether everything is going to work or not.
  validatePw() {
    if (this.pw.length > 0 || this.pwConf.length > 0) {
      this.newPasswordForm.$setValidity(
        'length',
        this.pw.length >= 8 && this.pwConf.length >= 8
      );
    }

    // Do the password and the password confirmation field match? If not, the user may have mistyped the new password.
    if (this.pw.length > 0 && this.pwConf.length > 0) {
      this.newPasswordForm.$setValidity('match', this.pw === this.pwConf);
    }
  }

  createPassword() {
    // Double check our password lengths and match again when the user attempts to submit.
    const length = this.pw.length >= 8 && this.pwConf.length >= 8;
    const match = this.pw === this.pwConf;

    // If the user clicks the button without entering anything in, this will flag that.
    this.newPasswordForm.$setValidity('length', length);

    if (length && match) {
      this.api.useraccount
        .resetpasswordrequests(this.$routeParams.code, this.pw)
        .then((response) => {
          if (response.data.requiresTandCAcceptance) {
            this.DestinationService.needsTermsOfUse();
          }

          // The user's first authentication is normally via creating a password for his/her account. We won't send
          // him/her back to the Sign In page to authenticate again using the same password the user just entered.
          // Instead the user will be progressed along toward the final destination with any required stops in between.
          this.DestinationService.callAfterAuthenticated().then(() => {
            this.DestinationService.nextDestination();
          });
        });
    }
  }
}
